import { render, staticRenderFns } from "./NuovaDelegaModal.vue?vue&type=template&id=7f6b4454&"
import script from "./NuovaDelegaModal.vue?vue&type=script&lang=js&"
export * from "./NuovaDelegaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NuovaDelegaModal.vue"
export default component.exports